define(function (require) {

    window.lpTag = window.lpTag || {};

    var _ = require('underscore');
    var lpUtils = require('utils/lpUtils');
    var ViewController = require('web-agent-framework/ViewController');
    var lpAMSController = require('web-agent-assets-js/lpAMSController');
    var HtmlTextFilter = require('web-agent-utils/HtmlTextFilter');
    var agentLEManager = require('web-agent-utils/agentLEManager');

    // Html directive processing for plain text.
    var HTMLFilterDirectives = {
        'A': function (elm) {
            var output,
                template = '[{text}](Link:{link})';

            var text = elm.innerText || elm.textContent;
            output = template.replace('{text}', text).replace('{link}', elm.href);
            return output;
        },
        'IMG': function (elm) {
            var output,
                template = '[Image:{image}]';

            output = template.replace('{image}', elm.src);
            return output;
        },
        'BR': function (elm) {
            return '\r\n';
        }
    };
    var htmlTextFilter = new HtmlTextFilter({
        directives: HTMLFilterDirectives
    });


    var UnformattedTextChatDialogViewController = ViewController.extend({
        ControllerName: "UnformattedTextChatDialogViewController",

        LPViewMap: {
            dialog: ".lpview_unformatted_text_dialog",
            closeButton: ".lpview_close_unformatted_text_dialog",
            selectButton: ".lpview_copy_unformatted_text_button",
            textarea: ".lpview_unformatted_text_textarea"
        },

        initialize: function (constructorData) {
            this.chatId = constructorData.chatId;
            this.dialogView = this.getFirstElement(this.LPViewMap.dialog);
            this.textarea = this.getFirstElement(this.LPViewMap.textarea);
            this.chatsRootModelPath = constructorData.chatsRootModelPath;

            // Setting up the transformers.
            this.transformers = {};
            this.transformers[lpTag.WebAgent.logicController.engagementTypes.realTimeChat] = new RealTimeTranscriptTransformer(this);
            this.transformers[lpTag.WebAgent.logicController.engagementTypes.asyncMessaging] = new MessagingTranscriptTransformer(this);
        },

        events: function () {
            this.bindViewEvent({selector: this.LPViewMap.closeButton, DOMEvent: "click", callback: this.hideDialog});
            this.bindViewEvent({view: this.dialogView, DOMEvent: "keyup", callback: this.keyUpPressedOnDialog});
            this.bindViewEvent({selector: this.LPViewMap.selectButton, DOMEvent: "click", callback: this.handleSelectButtonClicked});
        },

        render: function () {
        }
    });

    UnformattedTextChatDialogViewController.prototype.updateChatId = function (chatId) {
        if (this.chatId !== chatId) {
            this.chatId = chatId;
            this.textarea.value = ''; // Clearing the content of the textarea in case we switched the focus to a different chat.
            this.lpHide();
        }
    };

    UnformattedTextChatDialogViewController.prototype.showDialog = function () {
        this.lpShow();
        this.focus(this.textarea);

        // only process the unformatted transcript when showing the dialog.
        this.textarea.value = this.getUnformattedText();
        this.textarea.select();

        var self = this;
        setTimeout(function () {
            // Firefox fix for scroll top after select.
            self.textarea.scrollTop = 0;
        }, 0);


    };

    UnformattedTextChatDialogViewController.prototype.hideDialog = function () {
        this.lpHide();
    };

    UnformattedTextChatDialogViewController.prototype.keyUpPressedOnDialog = function (e) {
        var keyCode = ('which' in e) ? e.which : e.keyCode;
        if (keyCode === 27) { // ESC
            this.lpHide();
        }
        this.stopPropagation(e);
        this.preventDefault(e);
    };

    UnformattedTextChatDialogViewController.prototype.handleSelectButtonClicked = function (e) {
        // in IE11 the scroll position jump to TOP when using the select function.
        // we keeping the current position of the scroll, selecting the text and re assign the scroll position.
        var capturedTextScrollPosition = this.textarea.scrollTop;
        this.textarea.select();
        this.textarea.scrollTop = capturedTextScrollPosition;
    };


    UnformattedTextChatDialogViewController.prototype.getUnformattedText = function () {
        // get's the list of rew events from the model.
        var linesEvents = this.getModelParam(this.chatsRootModelPath + this.chatId + '.chatInfo.events.event');

        // resolving the engagement type in order to choose the transformer strategy.
        var engagementType = lpTag.WebAgent.logicController.getEngagementTypeByChatId(this.chatId, this.chatsRootModelPath);

        // setting the transformer based on the engagement type.
        var transformer = this.transformers[engagementType];

        // filter the current lines based on the transformer predicate to only contain content lines.
        var transcriptLines = _.filter(linesEvents, transformer.filterPredicate);

        // transforming the events to text transcript.
        return transformer.transformToText(transcriptLines);
    };

    /**
     * RealTime chat transformer, Transform RT lines Events to plain text representation.
     * @param vcContext
     * @returns {{transformToText: transformToText, filterPredicate: filterPredicate}}
     * @constructor
     */
    function RealTimeTranscriptTransformer(vcContext) {
        // var self = this;
        var AUTOMATED_LINE_TEXT = ' [' + vcContext.translate('chatAutomatedLine') + ']';
        var PRIVATE_LINE_TEXT = ' [' + vcContext.translate('chatPrivateLine') + ']';

        function transformToText(lines) {
            return _.map(lines, function (line) {
                return getFormattedLine(line);
            }).join('\n\n');
        }

        function filterPredicate(line) {
            var isPCILine = !!(line && line.args);
            var isValidLine = line.hasOwnProperty('source') && !(!line.text && line.by === "info");
            var isValidPCILine = isPCILine && isValidLine && (line.args && lpTag.WebAgent.logicController.hasSecureFormsFeature());
            var isLineStatus = line && (line.type || line['@type']) === 'line-status';

            return (isPCILine && isValidPCILine && !isLineStatus) || (!isPCILine && isValidLine && !isLineStatus);
        }

        function getFormattedLine(line) {
            var lineData = getLineData(line);
            var header = [lineData.by, lineData.type, ', ', lineData.date, ', ', lineData.time].join('');
            var formattedText = [header, lineData.text].join('\n');
            return formattedText;
        }

        function getLineData(line) {
            return {
                type: getTypeText(line),
                by: getLineBy(line),
                text: getLineText(line),
                time: getTime(line),
                date: getDate(line)
            };
        }

        function getLineBy(line) {
            return line.agentDeleted ? line.by + ' ' + agentLEManager.translateLE('LEWebAgent.agent_deleted_indication') : line.by;
        }

        function getLineText(line) {
            if (line) {
                if (line.text || line.transcriptText) {
                    // ensure that the 'text' is actual string.
                    var lineText = (line.transcriptText && line.transcriptText.toString()) || (line.text && line.text.toString());

                    // trimming the new lines and whitespaces
                    lineText = lineText.replace(/^\s+|\r+|\n+$/g,'');
                    var sanitizedText = lpUtils.decodeHTML(vcContext.sanitizeText(lineText).text);
                    return htmlTextFilter.processHTML(sanitizedText);
                }
                else if (line.textType === 'rich-content') {
                    return '[' + agentLEManager.translateLE('LEWebAgent.structured_content_plain_text') + ']';
                }
            }
            return '';
        }

        function getTypeText(line) {
            if (line.source == 'system') {
                return AUTOMATED_LINE_TEXT;
            }

            switch (line.subType) {
                case 'NON_RESPONSIVE':
                case 'STALLER':
                    return AUTOMATED_LINE_TEXT;

                case 'ONLY_TO_REP':
                    return PRIVATE_LINE_TEXT;

                case 'REGULAR':
                    return '';

                default:
                    return '';
            }

        }

        function getTime(line) {
            var rowTime = line.timeL || line.time;
            return vcContext.formatTime(rowTime, false);
        }

        function getDate(line) {
            var rowTime = line.timeL || line.time;
            return lpUtils.formatDateAsString(rowTime, true);
        }

        return {
            transformToText: transformToText,
            filterPredicate: filterPredicate
        };
    }

    /**
     * Async Messaging chat transformer, Transform Messaging lines Events to plain text representation.
     * @param vcContext
     * @returns {{transformToText: transformToText, filterPredicate: filterPredicate}}
     * @constructor
     */
    function MessagingTranscriptTransformer(vcContext) {
        var AUTOMATED_LINE_TEXT = '[' + vcContext.translate('chatAutomatedLine') + ']';

        function transformToText(lines) {
            var uniqueLines = getUniqLines(lines);

            //add to each line start and end separator indication when needed. also we get it already from queryMessages/history.
            // this is because when the dialog start/end on live (while open in the UI) - we won't have the indications on the lines.
            var dialogs = lpTag.WebAgent.logicController.getAllDialogsOfConversation(vcContext.chatId, vcContext.chatsRootModelPath);
            lpTag.WebAgent.logicController.addIndicationToStartAndEndDialogLines(uniqueLines, dialogs);

            return _.map(uniqueLines, function (line) {
                return getFormattedLine(line);
            }).join('\n\n');
        }

        function getUniqLines(lines) {
            var uniqLines = [];
            var lastServerTimestamp;
            var sortedLines = _.sortBy(lines, 'serverTimestamp');
            _.each(sortedLines, function (line) {
                if (line.serverTimestamp !== lastServerTimestamp) {
                    uniqLines.push(line);
                }
                lastServerTimestamp = line.serverTimestamp;
            });
            return uniqLines;
        }

        function filterPredicate(line) {
            // The lines are sorted by server timestamp - only lines that arrive from the server have this property.
            // Making sure that this property exists ensures that the sorting will work and that there won't be
            // duplicate lines due to placeholders for lines we send before they arrive from the server.
            return line && line.contentType && _.contains(lpAMSController.CONTENT_TYPES, line.contentType) && !!line.serverTimestamp;
        }

        function getFormattedLine(line) {
            var header;
            var lineData = getLineData(line);
            var by = getBy(lineData);
            header = [by, lineData.date, lineData.time].join(', ');
            var formattedText = [header, lineData.text].join('\n');
            return addSeparationLinesIfNeeded(line, formattedText);
        }

        function addSeparationLinesIfNeeded(line, formattedText) {
            var dialog = lpTag.WebAgent.logicController.getDialogOfConversation(line.conversationId, line.dialogId, vcContext.chatsRootModelPath);
            var dialogType = dialog && dialog.dialogType;
            formattedText = addSeparationLineIfNeededBySeparatorType(line.firstLineOfDialog, formattedText, dialogType, 'dialogStart');
            formattedText = addSeparationLineIfNeededBySeparatorType(line.lastLineOfDialog, formattedText, dialogType, 'dialogEnd');
            return formattedText;
        }

        function addSeparationLineIfNeededBySeparatorType(hasSeparatorIndication, formattedText, dialogType, separationType) {
            var separationLine;
            var tempLinesArray;
            if (hasSeparatorIndication && isDialogSeparationNeededForDialogType(dialogType, separationType)) {
                separationLine = getDialogSeparationText(dialogType, separationType);
                tempLinesArray = (separationType === 'dialogStart') ? [separationLine, formattedText] : [formattedText, separationLine];
                formattedText = tempLinesArray.join('\n\n');
            }
            return formattedText;
        }

        /**
         * Check dialog separator element is needed for the dialogId and type
         * @param dialogType
         * @param separationType - start/end
         */
        function isDialogSeparationNeededForDialogType(dialogType, separationType) { //might also check on the separation type
            var isNeeded = false;
            switch (dialogType) {
                case lpTag.WebAgent.logicController.dialogTypes.POST_SURVEY:
                    isNeeded = true;
                    break;
            }
            return isNeeded;
        }

        function getDialogSeparationText(dialogType, separationType) {
            var text = '';
            switch (dialogType) {
                case lpTag.WebAgent.logicController.dialogTypes.POST_SURVEY:
                    text = vcContext.translate('post_survey' + '_' + separationType);
                    break;
            }
            return text;
        }

        function getLineData(line) {
            var data = {
                type: getType(line),
                by: getLineBy(line),
                text: getLineText(line),
                time: getTime(line),
                date: getDate(line)
            };

            return data;
        }

        function getLineBy(line) {
            return line.agentDeleted ? line.by + ' ' + agentLEManager.translateLE('LEWebAgent.agent_deleted_indication') : line.by;
        }

        function getLineText(line) {
            var lineText = line && line.text;
            if (line && line.contentType) {
                switch (line.contentType) {
                    case lpAMSController.CONTENT_TYPES.TEXT_PLAIN:
                        lineText = line.text;
                        break;
                    case lpAMSController.CONTENT_TYPES.EXTERNAL_FILE:
                    case lpAMSController.CONTENT_TYPES.HOSTED_FILE:
                        lineText = '[' + line.fileType + '] ' + line.text;
                        break;
                    case lpAMSController.CONTENT_TYPES.RICH_CONTENT:
                        lineText = '[' + agentLEManager.translateLE('LEWebAgent.structured_content_plain_text') + ']';
                        break;
                }
            }

            if (lineText) {
                lineText = lineText.replace(/^\s+|\r+|\n+$/g, '');
                return lpTag.WebAgent.smileyEmojisController.replaceEmojiCodesByAlternate(lineText).trim();
            }

            return '';
        }

        function getTime(line) {
            var rowTime = line.timeL || line.time;
            return vcContext.formatTime(rowTime, false);
        }

        function getDate(line) {
            var rowTime = line.timeL || line.time;
            return lpUtils.formatDateAsString(rowTime, true);
        }

        function getBy(line) {
            return (line.type ? line.by + ' ' + line.type : line.by);
        }

        function getType(line) {
            if(line.source == 'system') {
                return AUTOMATED_LINE_TEXT;
            }
        }

        return {
            transformToText: transformToText,
            filterPredicate: filterPredicate
        };
    }


    return UnformattedTextChatDialogViewController;

});
